import React, { Fragment, useEffect, useState } from "react";
import { Form, Col, Row, Card } from "react-bootstrap";

import "../../../styles/styles.css";
import { ADDRESS_TYPES, RELATIONSHIP } from "../../../constants/constants";
import { getFormattedDate, getFullName } from "../../../util/helpers";
import {
  getAddressValue,
  getRelationDetails,
  getRelationShipName
} from "../../../util/onBoardingDataFilters";

const EPFPartB = ({
  personalDetails,
  updatePersonalDetails,
  relationShipList
}) => {
  useEffect(() => {
    findRelationShips();
  }, [personalDetails]);

  const fullName = getFullName(personalDetails);

  const [state, setstate] = useState({ father: "", mother: "", spouse: "" });

  const isSpouseFieldDisabled = () => {
    if (state.spouse === "" || (state.spouse && !state.spouse.id)) {
      return true;
    } else if (state.father !== "" && state.father.isEPSNominee === 1) {
      return true;
    } else if (state.mother !== "" && state.mother.isEPSNominee === 1) {
      return true;
    } else {
      return false;
    }
  };

  const isFatherFieldDisabled = () => {
    if (state.father === "") {
      return true;
    } else if (state.spouse !== "" && state.spouse.isEPSNominee === 1) {
      return true;
    } else {
      return false;
    }
  };

  const isMotherFieldDisabled = () => {
    if (state.mother === "") {
      return true;
    } else if (state.spouse !== "" && state.spouse.isEPSNominee === 1) {
      return true;
    } else {
      return false;
    }
  };

  const findRelationShips = () => {
    const { familyMembers } = personalDetails;
    if (familyMembers != null && familyMembers.length > 0) {
      const father = getRelationDetails(RELATIONSHIP.FATHER.id, familyMembers);
      const mother = getRelationDetails(RELATIONSHIP.MOTHER.id, familyMembers);
      const spouse = getRelationDetails(RELATIONSHIP.HUSBAND.id, familyMembers);
      setstate({
        ...state,
        father: father || "",
        mother: mother || "",
        spouse: spouse || ""
      });
    }
  };

  return (
    <Fragment>
      <Card>
        <Card.Header className="text-center">
          Part – B (EPS) (Para 19)
        </Card.Header>
        <Card.Body>
          <p className="text-danger text-center">
            *** Note: Either of the Spouse / One or both parents should be
            selected.
          </p>
          <p>
            I hereby furnish below particulars of the members of my family who
            would be eligible or receive Widow/Children pension in the event of
            my death.
          </p>

          <Row>
            <Col sm={1}>Choice</Col>
            <Col sm={3}>Name of the family member</Col>
            <Col sm={4}>Address of the family member</Col>
            <Col sm={2}>Date of Birth</Col>
            <Col sm={2}>Relationship with the member</Col>
          </Row>
          <Form.Group as={Row} controlId="nominee1">
            <Col sm={1}>
              <Form.Check
                size="lg"
                type="checkbox"
                className="epf_part_b_checkbox"
                name="checkNominee2"
                disabled={isSpouseFieldDisabled()}
                checked={state.spouse.isEPSNominee}
                onChange={() =>
                  updatePersonalDetails(
                    "isEPSNominee",
                    state.spouse.isEPSNominee === 1 ? 0 : 1,
                    "familyMembers",
                    state.spouse.id
                  )
                }
              />
            </Col>
            <Col sm={3}>
              <Form.Control
                size="sm"
                required
                type="text"
                placeholder="Name of the family member"
                name="nameOfFamilyMember1"
                value={state.spouse && state.spouse.fullName}
                disabled
              />
            </Col>
            <Col sm={4}>
              <Form.Control
                size="sm"
                required
                type="text"
                name="addressOfFamilyMember1"
                placeholder="Address of the family member"
                value={
                  state.spouse &&
                  state.spouse.id &&
                  getAddressValue(
                    "city",
                    personalDetails.addresses,
                    ADDRESS_TYPES.CURRENT
                  )
                }
                disabled
              />
            </Col>
            <Col sm={2}>
              <Form.Control
                size="sm"
                required
                type="date"
                name="dob1"
                placeholder="Date of Birth"
                value={
                  state.spouse &&
                  getFormattedDate(
                    state.spouse.dateOfBirth,
                    undefined,
                    "YYYY-MM-DD"
                  )
                }
                disabled
              />
            </Col>
            <Col sm={2}>
              <Form.Control
                size="sm"
                required
                type="text"
                name="relationWith1"
                placeholder="Relationship"
                value={
                  state.spouse &&
                  getRelationShipName(
                    state.spouse.relationShipType,
                    relationShipList
                  )
                }
                disabled
              />
            </Col>
          </Form.Group>

          <p>
            Certified that I have no family as defined in para 2(vii) of
            Employee’s Pension scheme, 1995 and should I acquire a family
            hereafter I shall furnish particulars thereon in the above form.
          </p>
          <p>
            I hereby nominate the following person for receiving the monthly
            widow pension (admissible under para 16(2) a (i) & (ii) in the event
            without leaving any eligible member for receiving pension.
          </p>
          <Row>
            <Col sm={1}>Choice</Col>
            <Col sm={4}>Name and address of the Nominee</Col>
            <Col sm={3}>Date of Birth</Col>
            <Col sm={3}>Relationship with the member</Col>
            <Col sm={1} />
          </Row>

          <Form.Group as={Row} controlId="nominee1">
            <Col sm={1}>
              <Form.Check
                size="lg"
                type="checkbox"
                className="epf_part_b_checkbox"
                name="checkNominee1"
                disabled={isFatherFieldDisabled()}
                checked={state.father.isEPSNominee}
                onChange={() =>
                  updatePersonalDetails(
                    "isEPSNominee",
                    state.father.isEPSNominee === 1 ? 0 : 1,
                    "familyMembers",
                    state.father.id
                  )
                }
              />
            </Col>

            <Col sm={4}>
              <Form.Control
                size="sm"
                required
                type="text"
                placeholder="Name and address of the Nominee"
                name="nameAddressOfNominee1"
                value={state.father && state.father.fullName}
                disabled
              />
            </Col>
            <Col sm={3}>
              <Form.Control
                size="sm"
                required
                type="date"
                name="dob1"
                placeholder="Date of Birth"
                value={
                  state.father &&
                  getFormattedDate(
                    state.father.dateOfBirth,
                    undefined,
                    "YYYY-MM-DD"
                  )
                }
                disabled
              />
            </Col>
            <Col sm={3}>
              <Form.Control
                size="sm"
                required
                type="text"
                name="relationshipWithMember1"
                placeholder="Relationship with the member"
                disabled
                value={
                  state.father &&
                  getRelationShipName(
                    state.father.relationShipType,
                    relationShipList
                  )
                }
              />
            </Col>
            <Col sm={1} />
          </Form.Group>

          <Form.Group as={Row} controlId="nominee2">
            <Col sm={1}>
              <Form.Check
                size="lg"
                type="checkbox"
                className="epf_part_b_checkbox"
                name="checkNominee2"
                disabled={isMotherFieldDisabled()}
                checked={state.mother.isEPSNominee}
                onChange={() =>
                  updatePersonalDetails(
                    "isEPSNominee",
                    state.mother.isEPSNominee === 1 ? 0 : 1,
                    "familyMembers",
                    state.mother.id
                  )
                }
              />
            </Col>

            <Col sm={4}>
              <Form.Control
                size="sm"
                required
                type="text"
                placeholder="Name and address of the Nominee"
                name="nameAddressOfNominee2"
                value={state.mother && state.mother.fullName}
                disabled
              />
            </Col>
            <Col sm={3}>
              <Form.Control
                size="sm"
                required
                type="date"
                name="dob2"
                placeholder="Date of Birth"
                value={
                  state.mother &&
                  getFormattedDate(
                    state.mother.dateOfBirth,
                    undefined,
                    "YYYY-MM-DD"
                  )
                }
                disabled
              />
            </Col>
            <Col sm={3}>
              <Form.Control
                size="sm"
                required
                type="text"
                name="relationshipWithMember2"
                placeholder="Relationship with the member"
                disabled
                readOnly={true}
                value={
                  state.mother &&
                  getRelationShipName(
                    state.mother.relationShipType,
                    relationShipList
                  )
                }
              />
            </Col>
            <Col sm={1} />
          </Form.Group>

          <Row className="row mt-5">
            <Col sm={4}>
              <Form.Label>Date</Form.Label>
              <Form.Control
                size="sm"
                required
                disabled
                type="date"
                name="relationshipWithMember3"
                placeholder="Date"
                value={getFormattedDate(
                  personalDetails.declarationDate,
                  undefined,
                  "YYYY-MM-DD"
                )}
              />
            </Col>
            <Col sm={3}></Col>
            <Col sm={5}>
              <Form.Label>
                Signature or Thumb Impression of the Subscriber*
              </Form.Label>
              <Form.Control
                size="sm"
                required
                disabled
                type="text"
                name="signature"
                placeholder="Signature or Thumb Impression of the Subscriber"
                value={fullName}
              />
            </Col>
          </Row>
        </Card.Body>
      </Card>
      <Card className="mt-2">
        <Card.Header>CERTIFICATE BY EMPLOYER</Card.Header>
        <Card.Body>
          <p>
            Certified that the above Declaration and Nomination has been
            signed/thumb Impressed before me by Shri/Smt./Kum.
            <b>{` ${fullName}`}</b> employed in my establishment after he/she
            has read the entries have been read over to him/her by me and got
            confirmed by him/her.
          </p>
          <Row>
            <Col sm={4}>Place: ……………………</Col>
            <Col sm={4}></Col>
            <Col sm={4}>
              Signature of the employer or other authorized Officers of the
              establishment
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </Fragment>
  );
};

export default EPFPartB;
